import React, { useState } from 'react';
import Home from '../../images/nav/home.png';
import ChargeEvents from '../../images/nav/charge_events.png';
import User from '../../images/nav/user.png'; 

import { Dropdown, } from 'react-bootstrap';

import './navBar.scss';

import bar from '../../images/bar.png';
import logo from '../../images/logo/logo1.png';
import user from '../../images/user1.png';
import setting from '../../images/nav/settings.png';

import { SidebarData } from './SidebarData';

import { FaCog, FaBell, FaLock, FaUserAlt, FaSignOutAlt } from "react-icons/fa";
import { Link, NavLink } from 'react-router-dom';

const NavBar = () => {
  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);

  const exPath = document?.location?.pathname

  console.log(exPath)

  // if (exPath === "/") {
  //   const theElement = document.getElementsByClassName('nav-text')[0]
  //   if (theElement) {
  //     theElement.firstElementChild.className = 'active'
  //   }
  // }


  return (
    <>
      <div className="navbar-area ">
        <div className="navleft">
          <button onClick={showSidebar} className="navToggle"><img src={bar} alt="" /></button>
          <Link to="/"><img src={logo} alt="" /></Link>
        </div>
        <div className="navright "> 
          <Dropdown align="end" className="navUser" id="dropdown-menu-align-end">
         
            <span className="Uname">Julian Leudesdorff </span> <img src={user} alt="" />  
             
          </Dropdown>
        </div>
      </div>

      <nav className='sidebarNav'>
        <ul className='nav-menu-items' onClick={showSidebar}>
          {/* {SidebarData.map((item, index) => {
            return (
              <li key={index} className={item.cName}>
                <NavLink exact to={item.path}>
                  <img src={item.icon} />
                  <span className="text">{item.title}</span>
                </NavLink>
              </li>
            );
          })} */}
          <li className='nav-text'>
            <NavLink to="/" className={exPath === "/" || exPath==="/wallbox_single" ? "navSelected" : ""}>
            <img src={Home} />
                  <span className="text">Dashboard</span>
            </NavLink>
          </li>
          <li className='nav-text'>
            <NavLink to="/chargeEvents" className={exPath === "/chargeEvents" && "navSelected"}>
            <img src={ChargeEvents} />
                  <span className="text">Charge Events</span>
            </NavLink>
          </li>
          <li className='nav-text'>
            <NavLink to="/user" className={exPath === "/user" || exPath === "/user_single" || exPath === "/roles" || exPath === "/permissions"  ? "navSelected" : ""}>
            <img src={User} />
                  <span className="text">User</span>
            </NavLink>
          </li>
        </ul>
        <ul className="bottomList">
          <li><Link to="/"><img src={setting} /></Link></li>
        </ul>
      </nav>

    </>
  )
}

export default NavBar
